import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
// internal
import { getStyles as getDfltStyles } from './styles.css';
import block from './block.json';

export type SubsectionQuoteProps = {
	slug: string;
	getStyles?: (styles: any) => string;
	contentIsRight?: boolean;
} & ThemeProps &
	ChildrenProps;

/**
 * COMPONENT
 */
export const SubsectionQuote: FC<SubsectionQuoteProps> & BlockConfigs = ({
	slug,
	children,
	theme = {},
	contentIsRight = false,
	getStyles = getDfltStyles,
}) => {
	const { variant, blockTheme } = useThemeBlock(slug, theme);

	const trimmedSlug = slug.split('/');
	const modifierSlug = trimmedSlug[trimmedSlug.length - 1];

	const rootClass = cx(
		'supt-subsection',
		`supt-subsection--${modifierSlug}`,
		{ 'supt-section--contentIsRight': contentIsRight },
		getStyles(blockTheme)
	);

	return (
		<div className={rootClass} data-block={slug} data-variant={variant}>
			<div className="supt-subsection__content">{children}</div>
		</div>
	);
};

SubsectionQuote.slug = block.slug;
SubsectionQuote.title = block.title;
